import Alpine from "alpinejs";
import { trackEvent } from "../../modules/track/trackEvent";

Alpine.magic("track", () => (obj) => {
  trackEvent(obj);
});
